import {analyticsEvent} from '../../../analytics';
const innerLinks = [...document.querySelectorAll('.section .article sup')];
const modalCloseIcons = [...document.querySelectorAll('.links-block .close-cross')];
const modalBg = [...document.querySelectorAll('.links-block')];
const links = (function() {
    function _showPopup() {
        document.body.dataset.showlinks = true;
        analyticsEvent('Source', 'Click', 'Открыт попап "Источники"');
    }
    function _hidePopup() {
        document.body.dataset.showlinks = false;
    }
    function _hidePopupBg(e) {
        if (e.target.classList.contains('links-block')) {
            document.body.dataset.showlinks = false;
        }
    }
    function init() {
        innerLinks.forEach(link => {
            if (!link.classList.contains('reg')) {
                link.addEventListener('click', _showPopup);
            }
        });
        modalCloseIcons.forEach(link => {
            link.addEventListener('click', _hidePopup);
        });
        modalBg.forEach(link => {
            link.addEventListener('click', _hidePopupBg);
        });
    }
    return {
        init: init
    };
})();
export default links;
